const Plaintiffs = () => {
  return <div>Plaintiffs</div>;
};

export default Plaintiffs;
